"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
const types = __importStar(require("."));
/** @ignore */
var Message;
(function (Message) {
    function fromObject(obj) {
        if (obj instanceof types.BadSyntheticMessage)
            return obj;
        if (obj instanceof types.BlockAnchor)
            return obj;
        if (obj instanceof types.CreditPayment)
            return obj;
        if (obj instanceof types.DidUpdateExecutorVersion)
            return obj;
        if (obj instanceof types.MakeMajorBlock)
            return obj;
        if (obj instanceof types.NetworkUpdate)
            return obj;
        if (obj instanceof types.SequencedMessage)
            return obj;
        if (obj instanceof types.SignatureMessage)
            return obj;
        if (obj instanceof types.SignatureRequest)
            return obj;
        if (obj instanceof types.SyntheticMessage)
            return obj;
        if (obj instanceof types.TransactionMessage)
            return obj;
        switch (obj.type) {
            case types.MessageType.BadSynthetic:
            case "badSynthetic":
                return new types.BadSyntheticMessage(obj);
            case types.MessageType.BlockAnchor:
            case "blockAnchor":
                return new types.BlockAnchor(obj);
            case types.MessageType.CreditPayment:
            case "creditPayment":
                return new types.CreditPayment(obj);
            case types.MessageType.DidUpdateExecutorVersion:
            case "didUpdateExecutorVersion":
                return new types.DidUpdateExecutorVersion(obj);
            case types.MessageType.MakeMajorBlock:
            case "makeMajorBlock":
                return new types.MakeMajorBlock(obj);
            case types.MessageType.NetworkUpdate:
            case "networkUpdate":
                return new types.NetworkUpdate(obj);
            case types.MessageType.Sequenced:
            case "sequenced":
                return new types.SequencedMessage(obj);
            case types.MessageType.Signature:
            case "signature":
                return new types.SignatureMessage(obj);
            case types.MessageType.SignatureRequest:
            case "signatureRequest":
                return new types.SignatureRequest(obj);
            case types.MessageType.Synthetic:
            case "synthetic":
                return new types.SyntheticMessage(obj);
            case types.MessageType.Transaction:
            case "transaction":
                return new types.TransactionMessage(obj);
            default:
                throw new Error(`Unknown message '${obj.type}'`);
        }
    }
    Message.fromObject = fromObject;
})(Message = exports.Message || (exports.Message = {}));
//# sourceMappingURL=unions_gen.js.map